






















import Vue from 'vue';
import TagUtils, { Tag } from '@/utils/TagUtils';
import { DataTableHeader } from 'vuetify';

export default Vue.extend({
  computed: {
    headers(): DataTableHeader<Tag>[] {
      return [
        {
          text: this.$tc('tag.name'),
          value: 'name',
        },
        {
          text: this.$tc('healthProfessionField.label'),
          value: 'health_profession_field.name',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },

  data: (): {
    items?: Tag[];
  } => ({
    items: undefined,
  }),

  async mounted() {
    try {
      this.items = undefined;
      this.items = await TagUtils.specialty.api.list();
    } catch (error) {
      console.error(error);
    } finally {
      //
    }
  },

  methods: {
    async handleEdit(item: Tag) {
      await this.$router.push({
        name: 'tag-specialty-edit',
        params: { id: item.id.toString() },
      });
    },

    async handleCreate() {
      await this.$router.push({
        name: 'tag-specialty-create',
      });
    },
  },
});
